import {Button, Fab, useMediaQuery} from '@material-ui/core';
import {Add} from '@material-ui/icons';
import React from 'react';
import 'Users/components/UserAdministration/AddUsersMenu.sass';
import {UserViewProps} from 'Users/components/UserAdministration/UserAdministration';
import {UserRouteConstants} from 'Users/Routes';

const AddUsersMenu = (props: UserViewProps) => {
  const isDesktop = useMediaQuery((theme: any) => theme.breakpoints.up('lg'));

  return isDesktop ? (
    <div className="add-agents-menu">
      <Button
        variant="contained"
        color="primary"
        onClick={() => props.history.push(UserRouteConstants.ADD_USER)}
        className="user-administration__add-user-button"
      >
        <i className="fa fa-plus" />
        &nbsp;Add User
      </Button>
    </div>
  ) : (
    <>
      <Fab
        color="primary"
        className="users-menu__mobile-actions"
        onClick={() => props.history.push(UserRouteConstants.ADD_USER)}
      >
        <Add className="users-menu__plus-icon" />
      </Fab>
    </>
  );
};

export default AddUsersMenu;
